// extracted by mini-css-extract-plugin
export const contacts = "contacts-module--contacts--ayvLY";
export const contacts__list = "contacts-module--contacts__list--1Es07";
export const contacts__listItem = "contacts-module--contacts__list-item--1C5gf";
export const contacts__listItemLink = "contacts-module--contacts__list-item-link--2QFep";